import React from 'react';

import { CliveAvatar } from '~/components/Clive/CliveAvatar';
import Text from '~/components/core/TextComponents/Text';

export const ChatErrorState: React.FC<{ className?: string }> = ({ className }) => (
  <div className={className}>
    <CliveAvatar mood={CliveAvatar.MOOD.SAD} className="mb-16" size={100} />
    <Text className="text-slate-700">Something went wrong while loading the chat.</Text>
  </div>
);
